<template>
  <div>
    <el-dialog
      class="clientDownload download"
      :title="$t('立即下载')"
      :visible.sync="isVisible"
      :width="getDialogWidth"
      :before-close="handleClose"
      append-to-body
      center
    >
      <div
        class="container clearfix"
        :class="getLanguage"
      >
        <div
          v-if="showMobile"
          class="qrCodeItem"
        >
          <div class="qrCodeItemImg">
            <img :src="qrcode">
            <p class="mobileDown">
              {{ $t('移动端扫码下载') }}
            </p>
          </div>
        </div>
        <div
          v-if="showClient"
          class="clientContent"
        >
          <div
            v-if="deviceDownloadList.window === 'enable'"
            class="clientDownBox"
          >
            <a
              class="loginBtn"
              href="/client/windows/bin/zBox_installer.exe"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/windows.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/windows/bin/zBox_installer.exe"
                :title="$t('下载')"
              >Windows{{ $t('版') }}</a>
              <h5>{{ $t('适用于') }}win7/win8/win10</h5>
            </span>
          </div>
          <div
            v-if="deviceDownloadList.zdrive === 'enable'"
            class="clientDownBox downBoxVirtual"
          >
            <a
              class="loginBtn"
              href="/client/disk/bin/zDrive_installer.exe"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/windows.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/disk/bin/zDrive_installer.exe"
                :title="$t('下载')"
              >{{ $t('Windows盘符版') }}</a>
              <h5>{{ $t('适用于') }}win7/win8/win10</h5>
            </span>
          </div>
          <div
            v-if="deviceDownloadList.mac === 'enable'"
            class="clientDownBox downBoxMac"
          >
            <a
              class="loginBtn"
              href="/client/apple/mac/zBox_installer.dmg"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/Mac.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/apple/mac/zBox_installer.dmg"
                :title="$t('下载')"
              >Mac{{ $t('版') }}</a>
              <h5>{{ $t('适用于10.13和以上版本') }}</h5>
            </span>
          </div>
          <div
            v-if="deviceDownloadList.linux === 'enable'"
            class="clientDownBox"
          >
            <a
              class="loginBtn"
              href="/client/linux/bin/zBox_linux_installer.deb"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/linux.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/linux/bin/zBox_linux_installer.deb"
                :title="$t('下载')"
              >Linux{{ $t('版') }}</a>
              <h5>{{ $t('适用于Ubuntu 18.02和以上版本') }}</h5>
            </span>
          </div>
        </div>
        <div
          v-if="showMobile"
          class="mobileContent"
        >
          <div
            v-if="deviceDownloadList.android === 'enable'"
            class="clientDownBox"
          >
            <a
              class="loginBtn"
              href="/client/android/bin/zBox.apk"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/Android.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/android/bin/zBox.apk"
                :title="$t('下载')"
              >Android{{ $t('版') }}</a>
              <h5>{{ $t('适用于Android5.0以上') }}</h5>
              <p @click="androidSettingDialog = true">{{ $t('Android首次配置说明') }}</p>
            </span>
          </div>
          <div
            v-if="deviceDownloadList.ios === 'enable'"
            class="clientDownBox"
          >
            <a
              class="loginBtn"
              href="/client/apple/ios/public/zBox.ipa"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/iPhone.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/apple/ios/public/zBox.ipa"
                :title="$t('下载')"
              >iPhone{{ $t('版') }}</a>
              <h5>{{ $t('适用于iOS10.0或以上版本') }}</h5>
              <p @click="iPhoneSettingDialog = true">{{ $t('iPhone首次配置说明') }}</p>
            </span>
          </div>
          <div
            v-if="deviceDownloadList.outlook === 'enable'"
            class="clientDownBox downBoxOutlook"
          >
            <a
              class="loginBtn"
              href="/client/outlook/bin/zBox_outlookplugin.exe"
              :title="$t('下载')"
            >
              <span class="imgLocation">
                <img src="../../../static/image/clientDownload/Outlook.png">
              </span>
            </a>
            <span class="describeContent">
              <a
                href="/client/outlook/bin/zBox_outlookplugin.exe"
                :title="$t('下载')"
              >{{ $t('Outlook插件') }}</a>
              <h5>{{ $t('适用于Outlook2010/2013/2016') }}</h5>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="clientDownload"
      title="ios"
      width="960px"
      :visible.sync="iPhoneSettingDialog"
      :modal="false"
      :before-close="iosDialog"
      append-to-body
    >
      <span
        slot="title"
        class="dialog-footer"
      >
        <i
          class="el-icon-arrow-left returnDialog"
          @click="closeSettingDialog"
        />
        <span style="color: #1B2733">{{ $t('IOS 客户端配置说明') }}</span>
      </span>
      <div class="iosConfig clearfix">
        <p class="introduce">
          {{ $t('如果您使用标准版移动客户端，初次使用需要进行服务器地址配置') }}:
        </p>
        <div class="iosConfigStep">
          <div class="iosLeft">
            <p class="step">
              {{ $t('点击下载的应用，出现如下提示，该提示为正常现象') }}
            </p>
            <img src="../../../static/image/clientDownload/ios_Filez_prompt.png">
          </div>
          <div class="iosMiddle">
            <p class="step">
              {{ $t('点击设置-通用-设备管理：选择信任Lenovo(Beijing)Limited') }}>
            </p>
            <img src="../../../static/image/clientDownload/ios_Filez_limit.png">
          </div>
          <div class="iosRight">
            <p class="step">
              {{ $t('点击进入应用按照提示，扫描一下二维码或手工输入服务器地址完成配置') }}
            </p>
            <div class="iosConfigCode">
              <img
                class="settingUrl"
                :src="phoneQrcode"
                :alt="$t('iOS、Android客户端首次配置方法说明')"
              >
            </div>
            <p
              v-if="getLanguage === 'en'"
              class="tipsEn"
            >
              Scan QR Code
            </p>
            <p
              v-else
              class="tips"
            >
              扫一扫
            </p>
            <div class="configUrl">
              <p>{{ $t('或采用手工配置输入如下地址信息：') }}</p>
              <div class="showUrl">
                {{ serverUrl }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="clientDownload"
      title="android"
      width="960px"
      :visible.sync="androidSettingDialog"
      :modal="false"
      :before-close="androidDialog"
      append-to-body
    >
      <span
        slot="title"
        class="dialog-footer"
      >
        <i
          class="el-icon-arrow-left returnDialog"
          @click="closeSettingDialog"
        />
        <span style="color: #1B2733">{{ $t('Android 客户端配置说明') }}</span>
      </span>
      <div class="androidConfig clearfix">
        <p>
          {{ $t('如果您使用标准版移动客户端，初次使用需要进行服务器地址配置') }},
          {{ $t('推荐在客户端配置向导，通过扫描下面二维码进行配置；也可以手工输入服务器地址完成配置。') }}
        </p>
        <div class="androidConfigCode">
          <p>{{ $t('扫一扫') }}</p>
          <div class="androidCodeImg">
            <img
              class="settingUrl"
              :src="phoneQrcode"
              :alt="$t('iOS、Android客户端首次配置方法说明')"
            >
          </div>
        </div>
        <div class="configUrl">
          <p>{{ $t('或采用手工配置输入如下地址信息：') }}</p>
          <div class="showUrl">
            {{ serverUrl }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Util from 'js/util/util'
const { getData } = require('js/api/getdata').default

export default {
  name: 'ClientDownload',
  props: {
    visible: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      isVisible: this.visiible,
      iPhoneSettingDialog: false,
      androidSettingDialog: false,
      androidInputContent: '',
      iphoneInputContent: '',
      qrcodeUrl: '', // 二维码下载
      phoneQrcode: '', // 手机端配置
      serverUrl: '', // 服务器地址
      deviceDownloadList:{}
    }
  },
  computed: {
    getLanguage() {
      return Util.getLanguage()
    },
    showMobile() {
      return this.deviceDownloadList.android === 'enable' || this.deviceDownloadList.ios === 'enable'
    },
    showClient() {
      const client = ['window', 'mac', 'zdrive', 'outlook', 'linux']
      return client.some((val) => this.deviceDownloadList[val] === 'enable')
    },
    getDialogWidth() {
      let width = 960
      if (!this.showMobile) {
        width -= 560
      }
      if (!this.showClient) {
        width -= 300
      }
      return `${width}px`
    },
  },
  watch: {
    visible(oldVal) {
      this.isVisible = oldVal
    },
  },
  created() {
    this.getQrcode()
    this.clientDownload()
  },
  methods: {
    clientDownload() {
      getData('clientDownload').then((res) => {
        res.data.device_download_list.forEach((val) => {
          this.$set(this.deviceDownloadList, val.device, val.status)
        })
      })
    },
    getQrcode() {
      this.qrcode = `/v2/image/qrcode?t=${window.location.protocol}//${window.location.host}/qrcode.html&d=180`
      this.phoneQrcode = `/v2/image/qrcode?t={%22host%22:%22${window.location.protocol}//${window.location.host}%22}&d=200`
      this.serverUrl = `${window.location.protocol}//${window.location.host}`
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 返回按钮只关闭配置dialog，不关闭下载客户端dialog
    closeSettingDialog() {
      if (this.iPhoneSettingDialog) {
        this.iPhoneSettingDialog = false
      }
      if (this.androidSettingDialog) {
        this.androidSettingDialog = false
      }
    },
    // 关闭安卓配置dialog时也要关闭下载客户端dialog
    androidDialog() {
      this.androidSettingDialog = false
      this.isVisible = false
      this.$emit('update:visible', false)
    },
    // 关闭ios配置dialog时也要关闭下载客户端dialog
    iosDialog() {
      this.iPhoneSettingDialog = false
      this.isVisible = false
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="less">
.clientDownload.download{
  .el-dialog__body{
    padding: 60px;
  }
}
.clientDownload{
  .el-dialog__header{
    padding:0 20px;
    height: 55px;
    line-height: 55px;
    text-align: center;
    border-bottom: 1px solid #eee;
    .el-dialog__headerbtn {
      height: 22px;
      line-height: 22px;
      right: 10px;
      .el-dialog__close {
        font-size: 22px;
        color: #909399;
      }
    }
    .el-dialog__title{
      font-size: 16px;
      color: #1B2733;
      letter-spacing: 0.1rem;
    }
    .returnDialog{
      margin-top: 20px;
      float: left;
      font-size: 22px;
      cursor: pointer;
    }
  }
  .el-dialog__body{
    padding: 30px;
    color: #000;
    .androidConfig{
      margin: 0 140px;
      line-height: 30px;
      font-size: 14px;
      color: #1B2733;
      min-height: 340px;
      .androidConfigCode{
        float: left;
        width: 50%;
        text-align: center;
        .androidCodeImg{
          display: inline-block;
          margin-top: 10px;
          border: 1px solid #ccc
        }
      }
      .configUrl{
        float: right;
        width: 40%;
        .showUrl{
          border: 1px solid #ccc;
          padding: 0 50px 0 5px;
          display: inline-block;
          margin-top: 10px;
          border-radius: 3px;
          min-width: 150px;
          color: #000;
        }
        input.el-input__inner{
          border: 1px solid #ccc;
          padding: 0 50px 0 5px;
          display: inline-block;
          margin-top: 10px;
          border-radius: 3px;
          height: 30px;
          width: 205px
        }
      }
    }
    .iosConfig{
      text-align: left;
      min-height: 400px;
      .introduce{
        font-size: 16px;
        margin-left: 10px;
        color: #1B2733;
      }
      .iosConfigStep{
        clear: both;
        img{
          width: 159px;
        }
        .iosLeft{
          float: left;
          width: 260px;
          height: 380px;
          padding: 10px;
          .step{
            position: relative;
            padding: 0 0 10px 30px;
            line-height: 1.4;
            word-break: break-all;
            color: #1B2733;
          }
          .step:before {
            content: '1';
            font-size: 40px;
            line-height: 40px;
            color: #157bfb;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .iosMiddle{
          float: left;
          width: 270px;
          height: 380px;
          padding: 10px;
          .step{
            position: relative;
            padding: 0 0 10px 30px;
            line-height: 1.4;
            color: #1B2733;
          }
          .step:before {
            content: '2';
            font-size: 40px;
            line-height: 40px;
            color: #157bfb;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        .iosRight{
          float: left;
          width: 280px;
          height: 380px;
          padding: 10px;
          .step{
            position: relative;
            padding: 0 0 10px 30px;
            line-height: 1.4;
            word-break: break-all;
            color: #1B2733;
          }
          .step:before {
            content: '3';
            font-size: 40px;
            line-height: 40px;
            color: #157bfb;
            position: absolute;
            top: 0;
            left: 0;
          }
          .iosConfigCode{
            display: inline-block;
            margin-top: 10px;
            border: 1px solid #ccc;
            .settingUrl{
              vertical-align: bottom;
            }
          }
          .tips{
            line-height: 1.4;
            padding: 15px 0;
            color: #1B2733;
            font-size: 14px;
            word-break: break-all;
          }
          .tipsEn{
            line-height: 1.4;
            padding: 5px 0;
            color: #1B2733;
            font-size: 14px;
            word-break: break-all;
          }
          .configUrl{
            p{
              line-height: 1.4;
              color: #1B2733;
              font-size: 14px;
            }
            .showUrl{
              border: 1px solid #ccc;
              padding: 0 50px 0 5px;
              display: inline-block;
              margin-top: 10px;
              border-radius: 3px;
              color: #000;
              height: 35px;
              line-height: 35px;
            }
            input.el-input__inner{
              border: 1px solid #ccc;
              padding: 0 50px 0 5px;
              display: inline-block;
              border-radius: 3px;
              margin-top: 10px
            }
          }
        }
      }
    }
    .en.container{
      .mobileContent{
        .clientDownBox{
          padding: 9px 0 0 10px;
        }
      }
    }
    .container{
      .qrCodeItem{
        float: left;
        width: 240px;
        height: 100%;
        text-align: center;
        .qrCodeItemImg{
          padding-top: 9px;
          img{
            width: 180px;
            height: 180px;
          }
          .mobileDown{
            margin-top: 24px;
            font-size: 14px;
          }
        }
      }
      .mobileContent{
        float: right;
        width: 282px;
        .clientDownBox{
          a{
            color: #1B2733;
            font-size: 20px;
            line-height: 26px;
          }
          display: block;
          width: 295px;
          padding: 9px 0 0 0;
          height: 86px;
          box-sizing: border-box;
          .loginBtn{
            display: block;
            line-height: 40px;
            font-size: 16px;
            color: #fff;
            border-radius: 3px;
            .imgLocation{
              float: left;
              height: 46px;
              width: 46px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .describeContent{
            line-height: 1.5;
            float: left;
            margin-left: 10px;
            h5{
              font-size: 14px;
              color: #637282;
              font-weight: unset;
              word-break: break-word;
            }
            p{
              color: #0A64FA;
              text-decoration: underline;
              cursor: pointer
            }
          }
        }
      }
      .clientContent{
        float: right;
        width: 282px;
        .clientDownBox{
          a{
            color: #1B2733;
            font-size: 20px;
            line-height: 26px;
          }
          display: block;
          width: 282px;
          padding: 9px 0 0 20px;
          height: 86px;
          box-sizing: border-box;
          .loginBtn{
            display: block;
            line-height: 40px;
            font-size: 16px;
            color: #fff;
            border-radius: 3px;
            .imgLocation{
              float: left;
              height: 46px;
              width: 46px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .describeContent{
            line-height: 1.5;
            float: left;
            margin-left: 10px;
            h5{
              font-size: 14px;
              color: #637282;
              font-weight: unset;
              max-width: 200px;
              word-break: break-word;
            }
            p{
              color: #0A64FA;
              text-decoration: underline;
              cursor: pointer
            }
          }
        }
      }
    }

  }
}
</style>
